import { TableColumn } from "src/app/models/TableColumn";

// formatter.util.ts
export class Formatter {
    static format(value: any, column: TableColumn, row: any): string {
        if (!column.format) return value !== undefined && value !== null ? String(value) : '';

        if (column.format.customFormatter) {
            return column.format.customFormatter(value, row);
        }

        switch (column.format.type) {
            case 'date': return this.formatDate(value, column.format.dateFormat);
            case 'currency': return this.formatCurrency(value, column.format);
            case 'number': return this.formatNumber(value, column.format);
            case 'percent': return this.formatPercent(value, column.format);
            case 'boolean': return this.formatBoolean(value, column.format);
            default: return String(value);
        }
    }

    private static formatDate(value: any, format: string = 'yyyy-MM-dd'): string {
        if (!value) return '';
        const date = new Date(value);
        if (isNaN(date.getTime())) return '';

        const pad = (num: number) => num.toString().padStart(2, '0');

        // Handle 12-hour time format
        if (format.includes('hh') || format.includes('a')) {
            let hours = date.getHours();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // Convert 0 to 12

            return format
                .replace('yyyy', date.getFullYear().toString())
                .replace('MM', pad(date.getMonth() + 1))
                .replace('dd', pad(date.getDate()))
                .replace('hh', hours.toString())
                .replace('mm', pad(date.getMinutes()))
                .replace('ss', pad(date.getSeconds()))
                .replace('a', ampm);
        }

        // Default 24-hour formatting
        return format
            .replace('yyyy', date.getFullYear().toString())
            .replace('MM', pad(date.getMonth() + 1))
            .replace('dd', pad(date.getDate()))
            .replace('HH', pad(date.getHours()))
            .replace('mm', pad(date.getMinutes()))
            .replace('ss', pad(date.getSeconds()));
    }

    private static formatCurrency(value: any, format: any): string {
        const num = parseFloat(value);
        if (isNaN(num)) return '';

        const decimals = format.decimalPlaces ?? 2;
        const symbol = format.currencySymbol ?? '$';
        const fixed = num.toFixed(decimals);

        return `${symbol}${fixed}`;
    }

    private static formatNumber(value: any, format: any): string {
        const num = parseFloat(value);
        if (isNaN(num)) return '';

        const decimals = format.decimalPlaces ?? 2;
        return num.toFixed(decimals);
    }

    private static formatPercent(value: any, format: any): string {
        const num = parseFloat(value);
        if (isNaN(num)) return '';

        const decimals = format.decimalPlaces ?? 2;
        if ((num * 100) > 100) {
            return `${num.toFixed(decimals)}%`;
        }
        else{
            return `${(num * 100).toFixed(decimals)}%`;
        }
        
    }

    private static formatBoolean(value: any, format: any): string {
        const val = Boolean(value);
        if (format.trueDisplay || format.falseDisplay) {
            return val ? format.trueDisplay ?? 'Yes' : format.falseDisplay ?? 'No';
        }
        return val ? '✓' : '✗';
    }
}